import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'

type PropsT = {
  title: string
  onSendTest: () => void
  disabled?: boolean
}

const SendTest: React.FC<PropsT> = ({
  title,
  onSendTest,
  disabled = false,
}) => {
  const [css] = useStyletron()

  return (
    <Button
      className={css({
        height: '32px',
        fontSize: '14px',
        marginLeft: '16px',
      })}
      kind="secondary"
      disabled={disabled}
      onClick={onSendTest}
    >
      {title}
    </Button>
  )
}

export default SendTest
